import { nanoid } from 'nanoid';
import { localStorageService } from '../services/local-storage';
import { sessionStorageService } from '../services/session-storage';

const getCurrentTabId = (): string => {
    return sessionStorageService.getItem('TAB_ID') || nanoid(10);
};

const getCurrentTabStartTimestamp = (): number => {
    return Number(sessionStorageService.getItem('TAB_START_TIMESTAMP')) || Date.now();
};

const isUniqueTab = (tabId: string): boolean => {
    return tabId === localStorageService.getItem('TAB_ID');
};

export const initUniqueTabData = (): void => {
    // Always generate a fresh tab id, even if sessionStorage already has one.
    // Browser "Duplicate Tab" inherits sessionStorage from the source tab, so
    // reusing the inherited value would cause `localStorage.setItem('TAB_ID',
    // sameValue)` to NOT fire a `storage` event in the source tab, leaving
    // both tabs alive with the same TAB_ID — defeating the single-tab gate.
    const tabId = nanoid(10);
    const tabTimestamp = Date.now().toString();

    localStorageService.setItem('TAB_ID', tabId);
    localStorageService.setItem('TAB_START_TIMESTAMP', tabTimestamp);
    sessionStorageService.setItem('TAB_ID', tabId);
    sessionStorageService.setItem('TAB_START_TIMESTAMP', tabTimestamp);
};

export const checkCurrentTabUniqueness = (): {
    tabId: string;
    tabTimestamp: number;
    tabExpired: boolean;
    existingLStimestamp: string;
    isUniqueTab: boolean;
} => {
    const tabId = getCurrentTabId();
    const tabTimestamp = getCurrentTabStartTimestamp();
    const existingLStimestamp = localStorageService.getItem('TAB_START_TIMESTAMP');

    return {
        tabId,
        tabTimestamp,
        existingLStimestamp,
        isUniqueTab: isUniqueTab(tabId),
        tabExpired: !isUniqueTab(tabId),
    };
};
